function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { spacing } from '@naf/theme';
import { Label } from './label';
import { Input } from './input';

/** Date input wrapper */

export const DateWrapper = ({
  children,
  className,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(Container, _extends({
    className: className
  }, rest), children);
};
const Container = styled.form.withConfig({
  displayName: "dateInput__Container",
  componentId: "sc-1a76x52-0"
})(["> div:not(:last-child){margin-right:", ";}input{text-align:center;}"], spacing.space16);

/** Date field wrapper */

export const DateField = ({
  children,
  className,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(DateInput, _extends({
    className: className
  }, rest), children);
};
const DateInput = styled.div.withConfig({
  displayName: "dateInput__DateInput",
  componentId: "sc-1a76x52-1"
})(["display:inline-flex;flex-flow:column wrap;"]);

/** Day input */

export const Day = /*#__PURE__*/forwardRef(({
  onChange,
  id,
  nextId,
  className,
  ...rest
}, ref) => {
  const handleChange = e => {
    if (!!onChange) onChange(e);
    if (e.length >= 2) {
      if (!!nextId) {
        // @ts-ignore-next
        document.querySelector(`input[id='${nextId}']`).focus();
      }
      return;
    }
  };
  return /*#__PURE__*/React.createElement(DayInput, {
    className: className
  }, /*#__PURE__*/React.createElement(Label, {
    width: 70
  }, "Dato"), /*#__PURE__*/React.createElement(Input, _extends({
    ref: ref,
    name: "day",
    id: id,
    onChange: e => handleChange(e),
    placeholder: "dd",
    width: 70,
    pattern: "[1-9]|[0-2][0-9]|[3][01]",
    maxLength: 2
  }, rest)));
});
const DayInput = styled.div.withConfig({
  displayName: "dateInput__DayInput",
  componentId: "sc-1a76x52-2"
})([""]);

/** Month input */

export const Month = /*#__PURE__*/forwardRef(({
  onChange,
  id,
  nextId,
  className,
  ...rest
}, ref) => {
  const handleChange = e => {
    if (!!onChange) onChange(e);
    if (e.length >= 2) {
      if (!!nextId) {
        // @ts-ignore-next
        document.querySelector(`input[id='${nextId}']`).focus();
      }
      return;
    }
  };
  return /*#__PURE__*/React.createElement(MonthInput, {
    className: className
  }, /*#__PURE__*/React.createElement(Label, {
    width: 70
  }, "M\xE5ned"), /*#__PURE__*/React.createElement(Input, _extends({
    ref: ref,
    id: id,
    name: "month",
    onChange: e => handleChange(e),
    placeholder: "mm",
    width: 70,
    pattern: "[1-9]|[0][0-9]|[1][0-2]",
    maxLength: "2"
  }, rest)));
});
const MonthInput = styled.div.withConfig({
  displayName: "dateInput__MonthInput",
  componentId: "sc-1a76x52-3"
})([""]);

/** Year input */

export const Year = /*#__PURE__*/forwardRef(({
  onChange,
  id,
  nextId,
  className,
  ...rest
}, ref) => {
  const handleChange = e => {
    if (!!onChange) onChange(e);
    if (e.length >= 4) {
      if (!!nextId) {
        // @ts-ignore-next
        document.querySelector(`input[id='${nextId}']`).focus();
      }
      return;
    }
  };
  return /*#__PURE__*/React.createElement(YearInput, {
    className: className
  }, /*#__PURE__*/React.createElement(Label, {
    width: 100
  }, "\xC5r"), /*#__PURE__*/React.createElement(Input, _extends({
    ref: ref,
    name: "year",
    id: id,
    onChange: e => handleChange(e),
    placeholder: "\xE5\xE5\xE5\xE5",
    width: 100,
    pattern: "[12][0-9]{3}",
    maxLength: "4"
  }, rest)));
});
const YearInput = styled.div.withConfig({
  displayName: "dateInput__YearInput",
  componentId: "sc-1a76x52-4"
})([""]);
//# sourceMappingURL=dateInput.js.map